<template lang="pug">
  div
    el-collapse(v-model="beneficiarioId")
      el-collapse-item(
        v-for="dependente in dependentes"
        :key="dependente.cpf"
        :title="dependente.nome",
        :name="dependente.cpf",
      )
        el-row
          el-col(:span="12")
            app-display(
              label="Nome:",
              :content="dependente.nome"
          )
          el-col(:span="12")
            app-display(
              label="CPF:",
              :content="dependente.cpf"
            )
          el-col(:span="12")
            app-display(
              label="Data de Nascimento:",
              :content="formatDate(dependente.dataNascimento, 'DD/MM/YYYY')"
            )
        listagem-documentos(
          v-if="dependente.documentos && dependente.documentos.length > 0"
          :documentos="dependente.documentos",
          :protocoloCadastroOriginal="protocolo"
          :idDependente="dependente._id"
          ownerDocumento="DEPENDENTE"
        )
</template>

<script>
import AppDisplay from './AppDisplay'
import ListagemDocumentos from './informacoesCadastro/ListagemDocumentos'
import format from '../utils/utils'

export default {

  components: {
    AppDisplay,
    ListagemDocumentos
  },

  props: {
    dependentes: {
      type: Array,
      required: true
    },
    protocolo: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      dependenteId: ''
    }
  },

  methods: {
    formatDate (data, formato) {
      return format.formatDate(data, formato)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/AppDependentes.vue